@if (providerResults().length === 0) {
  <app-no-data
    icon="pi pi-info-circle"
    label="project.steps.overallResults.noData.title"
    description="project.steps.overallResults.noData.message"
  />
} @else {
  <div class="flex flex-col gap-5">
    <h3 class="executive-summary-cards-title">
      {{ 'project.steps.overallResults.executiveSummary.finalProviderRankings' | transloco }}
    </h3>
    @for (result of providerResults(); track result.hrTool.id) {
      <app-provider-card [providerResult]="result" />
    }
  </div>
}
